@if (productsType$ | async; as obser) {
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
    <form-wrapper>
      <mat-stepper
        #linearVerticalStepper="matVerticalStepper"
        formArrayName="scpis"
        [linear]="true"
        (selectionChange)="stepClick($event)"
      >
        @for (scpi of scpis.controls; track scpi; let i = $index) {
          <mat-step
            [formGroup]="scpi"
            [stepControl]="scpis?.get([i])"
            completed="false"
          >
            <ng-container formGroupName="parameters">
              <ng-template matStepLabel>{{
                scpi.get('productName').value
              }}</ng-template>
              <div class="row row-flex">
                <div class="col-xs-12 col-sm-12 col-md-4 m-label">
                  <span class="pr-input-label">Mode de règlement</span>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-8 payment-type">
                  <!-- productsType?.find((product) => product[scpi.get('productName').value]) || types -->
                  @if (productsType) {
                    <pr-input-radio
                      formControlName="paymentType"
                      direction="column"
                      [isDefault]="false"
                      columns="3"
                      [options]="getType(scpi.get('productName').value)"
                    >
                    </pr-input-radio>
                  }
                </div>
              </div>
              @if (
                scpi.get('parameters').get('paymentType')?.value !== 'TRANSFERT'
              ) {
                <sub-title>
                  {{
                    scpi.get('parameters').get('paymentType').value == 'CHEQUE'
                      ? ' Chèque'
                      : 'Prélèvement SEPA'
                  }}
                  :</sub-title
                >
                <div class="row row-flex">
                  <div class="col-md-6 m-label">
                    <span class="pr-input-label"
                      >Le titulaire du compte est-il le souscripteur ?</span
                    >
                  </div>
                  <div class="col-md-6">
                    <pr-input-radio
                      formControlName="holderIsSubscriber"
                      columns="2"
                      [toggle]="true"
                      [isDefault]="false"
                    >
                    </pr-input-radio>
                  </div>
                </div>
              }
              @if (
                scpi.get('parameters').get('paymentType')?.value ==
                'DIRECT_DEBIT'
              ) {
                <ng-container formGroupName="directDebitIban">
                  <debit
                    [control]="'parameters.directDebitIban'"
                    [derrors]="derrors"
                  ></debit>
                </ng-container>
              }
              @if (
                scpi.get('parameters').get('paymentType')?.value == 'CHEQUE'
              ) {
                <check [derrors]="derrors"></check>
              }
              @if (
                scpi.get('parameters').get('holderIsSubscriber')?.value == false
              ) {
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column
                      label="Relation entre le titulaire du compte et le souscripteur"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <textarea
                        class="full-w"
                        type="text"
                        placeholder="Commencez à écrire ici"
                        rows="2"
                        formControlName="reltionshipHolderSubscriber"
                      ></textarea>
                    </pr-input-column>
                  </div>
                  <div class="col-md-12">
                    <pr-input-column
                      label="Motif d'intervention"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <textarea
                        class="full-w"
                        type="text"
                        placeholder="Commencez à écrire ici"
                        rows="2"
                        formControlName="interventionReason"
                      ></textarea>
                    </pr-input-column>
                  </div>
                </div>
              }
            </ng-container>
          </mat-step>
        }
      </mat-stepper>
    </form-wrapper>
    <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
  </form>
} @else {
  <pr-loader></pr-loader>
}
